export const QUERY_KEYS = {
    ACCOUNT_BY_ID: 'account-by-id',
    ACCOUNT_REVIEW_BY_ID: 'account-review-by-id',
    ACCOUNT_REVIEWS: 'account-reviews',
    ACCOUNTS: 'accounts',
    ADMIN_USER: 'admin-users',
    ALL_CUSTOMERS: 'all-customers',
    ALL_SCORECARD_LIST: 'all-scorecard-list',
    CONTENT_MANAGERS: 'content-managers',
    CSM_USER: 'csm-users',
    CUSTOMER_BY_ID: 'customers-by-id',
    CUSTOMERS: 'customers',
    DIGITAL_LABOR_POSTERS: 'digital-labor-poster',
    DIGITAL_SAFETY_MANUAL: 'digital-safety-manual',
    DOCUMENT_CATEGORY: 'document-category',
    DOCUMENT_CATEGORY_BY_ID: 'document-category-by-id',
    DOCUMENT_REQUEST: 'document-request',
    DOCUMENT_REQUEST_BY_ID: 'document-request-by-id',
    DOCUMENT_UPLOAD: 'document-upload',
    DOCUMENTS: 'documents',
    FOLDERS: 'folders',
    HIDDEN_HIRING_CLIENTS: 'hidden-hiring-clients',
    HIRING_CLIENT_BY_ID: 'hiring-client-by-id',
    HIRING_CLIENTS: 'hiring-clients',
    INACTIVE_USERS: 'inactive-users',
    MERGING_ACCOUNT_DETAIL: 'merging-account-detail',
    MY_DELETED_DOCUMENTS: 'my-deleted-documents',
    MY_DOCUMENTS: 'my-documents',
    NEWS_FEED: 'news-feed',
    NOTIFICATION: 'notification',
    OVERVIEW: 'overview',
    COMPLIANCE_STATUS: 'compliance-status',
    PLATFORMS: 'platforms',
    REGULATORY_ISSUE: 'regulatory-issue',
    SAFETY_MEETING: 'safety-meetings',
    SAFETY_MEETING_ASSOCIATION: 'safety-meetings-associations',
    SAFETY_MEETING_ASSOCIATION_BY_ID: 'safety-meetings-association-id',
    SALES_AGENT_USER: 'sales-agent-users',
    SCORECARD_DETAILS: 'scorecard-details',
    SCORECARD_EMAIL_LOGS: 'scorecard-email-logs',
    SCORECARD_LIST: 'scorecard-list',
    SCORECARDS: 'scorecards',
    USER_BY_ID: 'users-by-id',
    USER_IMAGE: 'user-image',
    USER_NOTIFICATION_PREFERENCES: 'user-ntf-pref',
    USER_USER: 'user-user',
    USERS: 'users'
};
